/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/9/22, 1:11 PM
 *
 */

import { useAppSelector } from 'stores';

import NavDropdown from '../NavDropdown';
import NavItem from '../NavItem';
import { schoolAdminNavRoutes } from '../sidebarRoutes';

const NavBar = () => {
  const roleSlug = useAppSelector((state) => state.auth.role);
  const navBarRoutes = roleSlug ? (roleSlug === 'school_admin' ? schoolAdminNavRoutes : []) : [];

  return (
    <div className="w-full text-sm">
      <ul className="flex w-full flex-col gap-y-1">
        {navBarRoutes.map((route) => {
          if (route.link === false) {
            if (route.modal) {
              const Modal = route.modal;

              return (
                <Modal key={`${route.id}-${route.title}`}>
                  <NavItem route={route} key={`${route.id}-${route.title}`} />;
                </Modal>
              );
            }
          }

          if (route.children) {
            return <NavDropdown subRoutes={route} key={`${route.id}-${route.title}`} />;
          }

          return <NavItem route={route} key={`${route.id}-${route.title}`} />;
        })}
      </ul>
    </div>
  );
};

export default NavBar;
